import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'

class CheckmarkIcon extends PureComponent {

  render () {
    const { sizeCss, textCss } = this.props
    return (
      <svg 
        className={`${sizeCss} ${textCss} fill-current`}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <polygon points="0 11 2 9 7 14 18 3 20 5 7 18" />
      </svg>
    )
  }
}

CheckmarkIcon.propTypes = {
  sizeCss: PropTypes.string,
  textCss: PropTypes.string
}

CheckmarkIcon.defaultProps = {
  sizeCss: '',
  textCss: 'text-white'
}

export default CheckmarkIcon